import { ReactNode, useCallback, useRef } from 'react';
import { FormattedMessage } from 'react-intl';
import { Button } from 'reactstrap';

// The templates page owns the editor modal; the page header button opens it
// through the handler the templates page registers here.
export const useCreateTemplateAction = (): {
  onCreateRef: (handler: () => void) => void;
  action: ReactNode;
} => {
  const createTemplateRef = useRef<(() => void) | null>(null);
  const onCreateRef = useCallback((handler: () => void) => {
    createTemplateRef.current = handler;
  }, []);

  const action = (
    <Button color="primary" onClick={() => createTemplateRef.current?.()}>
      <i className="fe fe-edit me-1" />
      <FormattedMessage
        id="app.views.administration.content_administration.templates.create"
        defaultMessage="Create template"
      />
    </Button>
  );

  return { onCreateRef, action };
};
